<template>
  <PDrawerTab
    :results-count="resultsCount"
    :tab-counters="loggedStaffCounters.fupChannels"
    @load="fetchChannels({ setCurrentPage: false })"
  >
    <PDrawerHeaderFilters allow-filter @sort:change="fetchChannels" />

    <PDrawerList
      is-follow-up
      title="Follow UP"
      empty-icon="bandaid"
      empty-message="Você respondeu todos os Follow Ups"
      :list="followUpChannels"
      :total="loggedStaffCounters.fupChannels.total"
    />
  </PDrawerTab>
</template>

<script>
import { mapGetters, mapState } from 'vuex'

import PDrawerHeaderFilters from '../PDrawerHeaderFilters.vue'
import PDrawerList from '../PDrawerList.vue'
import PDrawerTab from '../PDrawerTab.vue'

export default {
  components: { PDrawerHeaderFilters, PDrawerList, PDrawerTab },
  data() {
    return {
      listener: undefined
    }
  },
  computed: {
    ...mapState('channel/drawer', ['currentFilters']),
    ...mapState('channel/drawer', ['followUpChannels']),
    ...mapGetters('channel/staff', ['loggedStaffCounters']),
    resultsCount() {
      return this.followUpChannels?.length
    }
  },
  watch: {
    'currentFilters.tags': 'fetchChannels'
  },
  beforeUnmount() {
    if (this.listener) this.listener()
    this.$store.commit('channel/drawer/setCurrentPage', 0)
    this.$store.commit('channel/drawer/setFollowUpChannels', undefined)
  },
  methods: {
    async fetchChannels({ setCurrentPage = true } = {}) {
      if (setCurrentPage) {
        this.$store.commit('channel/drawer/setCurrentPage', 1)
      }

      if (this.listener) this.listener()

      this.listener = await this.$store.dispatch(
        'channel/drawer/fetchChannels',
        {
          mutation: 'setFollowUpChannels',
          starred: 'FOLLOW_UP'
        }
      )
    }
  }
}
</script>
